exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".hgH2QV5RiQIRmzMi3yKTP{width:0;height:0;overflow:hidden}", ""]);
// Exports
exports.locals = {
	"alert": "hgH2QV5RiQIRmzMi3yKTP"
};